import { render, staticRenderFns } from "./CateringList.vue?vue&type=template&id=1d658b5e&scoped=true"
import script from "./CateringList.vue?vue&type=script&lang=js"
export * from "./CateringList.vue?vue&type=script&lang=js"
import style0 from "./CateringList.vue?vue&type=style&index=0&id=1d658b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d658b5e",
  null
  
)

export default component.exports